import { GenericObject } from "utility/misc";

import pagerdutyConfig from "./config";

// -----------------------------------------------------------------------------

export default function redirectToPagerdutyOauthUrl(
  orgStore: GenericObject
): void {
  const params = new URLSearchParams({
    app_id: pagerdutyConfig.appID,
    redirect_url: encodeURI(
      `${window.location.origin}/environment/destinations/pagerduty/redirect`
    ),
    version: 2,
  } as any).toString();
  const oauthURL: string = `https://app.pagerduty.com/install/integration?${params}`;

  //
  // nosemgrep: javascript.browser.security.open-redirect.js-open-redirect
  window.location.href = oauthURL;
}
